import React from "react";
import Skeleton from "react-loading-skeleton";
import styles from "./TrendingJobsSkeleton.module.scss";

const JOB_COUNT = 5;

const TrendingJobsSkeleton = ({ count }) => {
  return (
    <div className={styles.wrapper}>
      {[...Array(count)].map((_, i) => (
        <div className={styles.item} key={i}>
          <Skeleton width={50} height={50} circle />
          <div className={styles.texts}>
            <Skeleton width={120} height={12} />
            <Skeleton width={60} height={5} />
            <Skeleton width={60} height={5} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default TrendingJobsSkeleton;
